import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-solutions',
  templateUrl: './new-solutions.component.html',
  styleUrls: ['./new-solutions.component.scss']
})
export class NewSolutionsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
